import React, { useContext, useEffect, useState } from "react";
import SideNavProfile from "./SideNavProfile";
import "./SideBar.css";
import SideMenuItem from "../SideMenuItem";
import { FormattedMessage, useIntl } from "react-intl";
import useSideBarLayout from "../../hooks/useSideBarLayout";
import BottomLayout from "./BottomLayout";
import SideBarLoader from "./SideBarLoader";
import { useLocation } from "react-router-dom";
import useHideSidebar from "../../hooks/useHideSidebar";
import { ThemeContext } from "../context/ThemeContext";

const SideBar = () => {
  const intl = useIntl();
  const { isDarkMode } = useContext(ThemeContext);
  const [isExpanded, setIsExpanded] = useState(false);
  const { mainMenu, bottomMenu, isExceed, loading, setLoading } =
    useSideBarLayout();
  const location = useLocation();
  const { hideSideBar } = useHideSidebar(location.pathname);
  useEffect(() => {
    if (hideSideBar) setLoading(false);
  }, [location]);
  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  const handleClickNavLink = (path) => {
    if (path === "mailto" || path.includes("https://")) {
      setIsExpanded(false);
    }
  };

  return (
    <nav className={`dashboard-nav ${isExpanded ? "expanded" : "collapsed"}`}>
      <ul>
        {loading ? (
          <SideBarLoader expanded={isExpanded} />
        ) : (
          !hideSideBar &&
          mainMenu?.map((item) => (
            <SideMenuItem
              key={item.path}
              to={item.path}
              label={item.label}
              iconDefault={item.iconDefault}
              iconActive={item.iconActive}
              isExpanded={isExpanded}
            />
          ))
        )}
      </ul>
      <div className="profile-actions">
        <ul style={{ marginBottom: 0 }}>
          {((isExceed && isExpanded) || !isExceed) && (
            <BottomLayout isExceed={isExceed}>
              {bottomMenu?.map((item, index) => (
                <React.Fragment key={item.path}>
                  <SideMenuItem
                    key={item.path}
                    to={item.path}
                    label={item.label}
                    iconDefault={item.iconDefault}
                    isExpanded={isExpanded}
                    handleClickNavLink={() => handleClickNavLink(item.path)}
                  />
                  {isExceed && index + 1 != bottomMenu?.length && "|"}
                </React.Fragment>
              ))}
            </BottomLayout>
          )}
        </ul>
        <button
          className={`toggle-nav ${isExpanded ? "expanded" : "collapsed"}`}
          onClick={toggleExpand}
          title={
            isExpanded
              ? intl.formatMessage({
                  id: "navbar.tooltip.collapse",
                  defaultMessage: "Collapse the menu",
                })
              : intl.formatMessage({
                  id: "navbar.tooltip.expand",
                  defaultMessage: "Expand the menu",
                })
          }
        >
          {isExpanded ? (
            <>
              <img
                src={
                  isDarkMode
                    ? "/ui/images/Truman-UI-collapseArrow-dark-mode.svg"
                    : "/ui/images/Truman-UI-collapseArrow.svg"
                }
                alt="Collapse Arrow"
              />
              <span id="collapse-text">
                <FormattedMessage
                  id="navbar.collapse"
                  defaultMessage="Collapse"
                />
              </span>
            </>
          ) : (
            <img
              src={
                isDarkMode
                  ? "/ui/images/Truman-UI-expandArrow-dark-mode.svg"
                  : "/ui/images/Truman-UI-expandArrow.svg"
              }
              alt="Expand Arrow"
            />
          )}
        </button>
        <SideNavProfile isExpanded={isExpanded} />
      </div>
    </nav>
  );
};

export default SideBar;
